import {authModuleName, authReducer} from 'modules/auth/slice';
import {IAuthState} from 'modules/auth/types';
import {bottomBarModuleName, bottomBarReducer} from 'modules/bottom-bar/slice';
import {IBottomBarState} from 'modules/bottom-bar/types';
import {cartModuleName, cartReducer} from 'modules/cart/slice';
import {ICartState} from 'modules/cart/types';
import {categoriesReducer, categoryModuleName} from 'modules/categories/slice';
import {ICategoriesState} from 'modules/categories/types';
import {errorsModuleName, errorsReducer} from 'modules/errors/slice';
import {IErrorState} from 'modules/errors/types';
import {loaderModuleName, loaderReducer} from 'modules/loader/slice';
import {ILoaderState} from 'modules/loader/types';
import {locationsModuleName, locationsReducer} from 'modules/locations/slice';
import {ILocationsState} from 'modules/locations/types';
import {onlineChatModuleName, onlineChatReducer} from 'modules/online-chat/slice';
import {priceAndBonusesModuleName, priceAndBonusesReducer} from 'modules/price-n-bonuses/slice';
import {IPriceAndBonusesState} from 'modules/price-n-bonuses/types';
import {productModuleName, productReducer} from 'modules/product-card/slice';
import {IProductState} from 'modules/product-card/types';
import {productsModuleName, productsReducer} from 'modules/products/slice';
import {TProductState} from 'modules/products/types';
import {requestLoggerModuleName, requestLoggerReducer} from 'modules/request-logger/slice';
import {IRequestLoggerState} from 'modules/request-logger/types';
import {userModuleName, userReducer} from 'modules/user/slice';
import {IUserState} from 'modules/user/types';
import {shieldModuleName, shieldReducer} from 'modules/shields/slice';
import {IShieldState} from 'modules/shields/types';
import {portalModuleName, portalReducer} from 'modules/portal/slice';
import {IPortalState} from 'modules/portal/types';
import {wishListModuleName, wishListReducer} from 'modules/wish-list/slice';
import {IWishListState} from 'modules/wish-list/types';
import {sliderModuleName, sliderReducer} from 'modules/slider/slice';
import {footerGlobalModuleName, footerGlobalReducer} from 'modules/footer/slice';
import {IFooterGlobalDataState} from 'modules/footer/types/state';
import {ISliderState} from 'modules/slider/types';
import {articlesModuleName, articlesReducer} from 'modules/blog/slice';
import {IArticlesState} from 'modules/blog/types';

export interface IRootReducer {
    [articlesModuleName]: IArticlesState;
    [authModuleName]: IAuthState;
    [bottomBarModuleName]: IBottomBarState;
    [cartModuleName]: ICartState;
    [categoryModuleName]: ICategoriesState;
    [errorsModuleName]: IErrorState;
    // [eventsModuleName]: IEventsState;
    [priceAndBonusesModuleName]: IPriceAndBonusesState;
    [portalModuleName]: IPortalState;
    [errorsModuleName]: IErrorState;
    [loaderModuleName]: ILoaderState;
    [locationsModuleName]: ILocationsState;
    [portalModuleName]: IPortalState;
    [productModuleName]: IProductState;
    // [productSubscriptionModuleName]: IProductSubscriptionState;
    [productsModuleName]: TProductState;
    [requestLoggerModuleName]: IRequestLoggerState;
    [shieldModuleName]: IShieldState;
    [userModuleName]: IUserState;
    [sliderModuleName]: ISliderState;
    [wishListModuleName]: IWishListState;
    [footerGlobalModuleName]: IFooterGlobalDataState;
}

export const rootReducer = {
    [articlesModuleName]: articlesReducer,
    [authModuleName]: authReducer,
    // [barcodeScannerModuleName]: barcodeScannerReducer,
    [bottomBarModuleName]: bottomBarReducer,
    [cartModuleName]: cartReducer,
    [categoryModuleName]: categoriesReducer,
    // [collectionsModuleName]: collectionsReducer,
    // [collectionXModuleName]: collectionXReducer,
    [errorsModuleName]: errorsReducer,
    // [eventsModuleName]: eventsReducer,
    [loaderModuleName]: loaderReducer,
    [locationsModuleName]: locationsReducer,
    // [loyaltyCardListModuleName]: loyaltyCardsListReducer,
    [onlineChatModuleName]: onlineChatReducer,
    [portalModuleName]: portalReducer,
    [priceAndBonusesModuleName]: priceAndBonusesReducer,
    [productModuleName]: productReducer,
    // [productSubscriptionModuleName]: productSubscriptionReducer,
    [productsModuleName]: productsReducer,
    [requestLoggerModuleName]: requestLoggerReducer,
    [shieldModuleName]: shieldReducer,
    [sliderModuleName]: sliderReducer,
    [userModuleName]: userReducer,
    [wishListModuleName]: wishListReducer,
    [footerGlobalModuleName]: footerGlobalReducer,
};
